<template>
  <v-tooltip :text="tooltip">
    <template v-slot:activator="{ props: tooltipProps }">
      <v-slider
        v-bind="tooltipProps"
        :label="label"
        :model-value="modelValue"
        :min="1"
        :max="10"
        step="1"
        thumb-label
        color="secondary"
        thumb-color="primary"
        @update:modelValue="(v) => emit('update:modelValue', v)"
      ></v-slider>
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
// The workflow Concurrency control (max helper agents running at once, 1–10), shared by the
// Advanced WorkflowEditor and the simple AutomationDetail so both surfaces edit the same
// WorkflowConfig.concurrency field with the same range and behavior. Label/tooltip are props
// because the simple lens uses plain-language copy; defaults are the Advanced editor's wording.
withDefaults(
  defineProps<{
    modelValue: number
    label?: string
    tooltip?: string
  }>(),
  {
    label: 'Concurrency',
    tooltip: 'Maximum number of helper agents to run concurrently.'
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
}>()
</script>
